<template>
  <div class="grid">
    <div class="col-12">

        
            <TabMenu :model="items" />
            
        
      </div>
  </div>
</template>
<script>
export default {
  name: 'NavBar',
  data () {
    return {
      items: [],
    }
  },
  computed: {
    isLoggedIn: function () { return this.$store.state.auth.status.loggedIn }
  },
  mounted() {
    this.items = [
                //{
                //    label: 'Dashboard',
                //    icon: 'pi pi-fw pi-home',
                //    to: '/',
                //    visible: () => this.isLoggedIn
                //},
                //{
                //    label: 'Domains',
                //    icon: 'pi pi-fw pi-calendar',
                //    to: '/domains',
                //    visible: () => this.isLoggedIn
                //},
                {
                    label: 'DNS',
                    icon: 'pi pi-fw pi-book',
                    to: '/dns-records',
                    visible: () => this.isLoggedIn
                },
                 {
                    label: 'Mail',
                    icon: 'pi pi-fw pi-calendar',
                    to: '/mail/accounts',
                    visible: () => this.isLoggedIn
                },
                {
                    label: 'Login',
                    icon: 'pi pi-fw pi-cog',
                    to: '/login',
                    visible: () => !this.isLoggedIn

                },
                //{
                //    label: 'Logout',
                //    icon: 'pi pi-fw pi-cog',
                //    //to: '/login',
                //    command: this.logout,
                //    visible: () => this.isLoggedIn
                //},
                {
                    label: 'Register',
                    icon: 'pi pi-fw pi-cog',
                    to: '/register',
                    visible: () => !this.isLoggedIn
                }
    ]
  },
  methods: {
    async logout () {
      await this.$store.dispatch('auth/logout')
      this.$router.push('/login')
    }
  }
}
</script>
<style>

</style>
